import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { MenuComponent } from './components/menu/menu.component';
import { CategoriaComponent } from './site/catalogos/categoria/categoria.component';
import { PlatillosComponent } from './site/catalogos/platillos/platillos.component';
import { LoginComponent } from './admin/login/login.component';
import { RegisterComponent } from './admin/register/register.component';
import { AuthGuardService as AuthGuard  } from './admin/auth-guard.service';


const routes: Routes = [
  { path:'menu', component: MenuComponent },         //Público
  { path:'menu/:code', component: MenuComponent },   //Público
  { path:'login', component: LoginComponent },       //Público
  { path:'register', component: RegisterComponent }, //Público

  { path: 'categorias', component: CategoriaComponent, canActivate: [AuthGuard] },
  { path: 'platillos', component: PlatillosComponent, canActivate: [AuthGuard] },
  
  { path: '**', pathMatch: 'full', redirectTo: 'menu'}
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }
